
import Headroom from "headroom.js";

export default function initHeadroom() {
	const config = { offset: 103 }
	document.querySelectorAll('.sticky-header, .sub-nav-panel').forEach((elem) => {
		const headroom = new Headroom(elem, config);
		headroom.init();
		if (jQuery(window.location.hash).length) headroom.unpin();
	});
}
